import { render } from "./ProductDetailsGallery.vue?vue&type=template&id=6ed1d07c"
import script from "./ProductDetailsGallery.vue?vue&type=script&lang=js"
export * from "./ProductDetailsGallery.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__